export default "__VITE_ASSET__Rj_oFajs__"